import React from "react";
import { SvgIcon } from "@mui/material";

const BoxSearchIcon = (props: any) => {
  return (
    <SvgIcon {...props}>
      <svg width="210" height="158" viewBox="0 0 210 158" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group">
          <path id="Path" opacity="0.3" d="M127.929 0.6384C127.309 0.2242 126.575 0 125.83 0H50.1739C49.4287 0 48.6949 0.2242 48.0746 0.6384L1 34.2C1 34.2 3.11826 38 4.78261 38H171.217C172.882 38 175 34.2 175 34.2L127.929 0.6384Z" fill="currentColor" />
          <path id="Path_2" d="M1 34V150.485C1 154.637 4.38544 158 8.56522 158H167.435C171.615 158 175 154.637 175 150.485V34H1Z" fill="#DEEEFA" />
          <path id="Path_3" d="M65 34L76.5 0H99.5L111 34H65Z" fill="#9CCBED" />
          <rect id="Rectangle" x="65" y="34" width="46" height="48" fill="#B9DCF6" />
          <g id="ZoomIn">
            <path id="Path_4" d="M205.949 134C205.168 134 204.386 133.702 203.79 133.105L186.582 115.897C185.389 114.706 185.389 112.772 186.582 111.58C187.775 110.387 189.707 110.387 190.899 111.58L208.107 128.788C209.3 129.98 209.3 131.913 208.107 133.105C207.511 133.702 206.73 134 205.949 134Z" fill="#22242D" />
            <circle id="Oval" cx="170.137" cy="95.1429" r="27.2" fill="white" />
            <path id="Shape" fillRule="evenodd" clipRule="evenodd" d="M141 95.1429C141 111.212 154.074 124.286 170.143 124.286C186.212 124.286 199.286 111.212 199.286 95.1429C199.286 79.0735 186.212 66 170.143 66C154.074 66 141 79.0735 141 95.1429ZM144.062 95.1431C144.062 80.7649 155.759 69.0679 170.138 69.0679C184.516 69.0679 196.213 80.7649 196.213 95.1431C196.213 109.521 184.516 121.218 170.138 121.218C155.759 121.218 144.062 109.521 144.062 95.1431Z" fill="#22242D" />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}

export default BoxSearchIcon;